const updateEquipments = {
  name: 'EQUIPO',
  conditionTrue: 'REACTIVADO',
  conditionFalse: 'INACTIVADO',
  newMaintenanceStatus: 'MANTENIMIENTO',
  newMaintenanceStatusTrue: 'ENVIADO A',
  newMaintenanceStatusFalse: 'RETORNO DE'
};

export default updateEquipments;
